import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_EBUY_SETTINGS = {
  samGov: { enabled: false },
  eBuy: {
    enabled: false,
    adminEmail: "",
    genEmail: "",
    inProgress: false,
    failedToSend: false,
    failedMessage: null,
  },
};

export const INITIAL_STATE = {
  settings: INITIAL_EBUY_SETTINGS,
  edits: {},
  error: false,
  isConnectionTested: false,
  isTesting: false,
  enabled: { samGov: false, eBuy: false, findATender: false },
};

export const integrationsSlice = createSlice({
  name: "integrations",
  initialState: INITIAL_STATE,
  reducers: {
    setSettings: (state, { payload }) => {
      state.settings = payload;
    },
    updateSettings: (state, { payload }) => {
      state.settings = { ...state.settings, ...payload };
    },
    setEdits: (state, { payload }) => {
      state.edits = { ...state.edits, ...payload };
    },
    resetEdits: (state) => {
      state.edits = {};
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setEnabled: (state, { payload }) => {
      state.enabled = payload;
    },
    setIsConnectionTested: (state, { payload }) => {
      state.isConnectionTested = payload;
    },
    setIsTesting: (state, { payload }) => {
      state.isTesting = payload;
    },
  },
});

export const { setSettings, updateSettings, setEdits, resetEdits, setError, setEnabled, setIsConnectionTested, setIsTesting } =
  integrationsSlice.actions;

export default integrationsSlice.reducer;
